// dependencies
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

import serializeObject from "../../utils/SerializeObject";

export const reviewCycleGetForms = CreateProcess({
	method: "GET",
	name: "getReviewCycleForms",
	type: "REVIEWCYCLE:GETFORMS",

	request: (props) => ({
		url: `/api/review-cycles/${props.reviewCycleID}/forms/`,
	}),

	success: (response) => fromJS(response.data),
});

export const reviewCycleGetDetails = CreateProcess({
	method: "GET",
	name: "getReviewCycleDetails",
	type: "REVIEWCYCLE:GETDETAILS",

	request: (props) => ({
		url: `/api/review_cycle/${props.reviewCycleID}/details/`,
	}),

	success: (response) => fromJS(response.data),
});

export const reviewCycleGetInfo = CreateProcess({
	method: "GET",
	name: "getReviewCycleInfo",
	type: "REVIEWCYCLE:GETINFO",

	request: (props) => {
		const queryParams = serializeObject(props.params);

		return {
			url: `/api/review_cycle/view/all/?${queryParams}`,
		};
	},

	success: (response) => {
		const { data } = response;
		const { totalCount } = data;
		const { cycles } = data;

		return {
			cycles,
			totalCount,
		};
	},
});

// this is to replace the old middleware CYCLE.GET
// in /assets/react/middleware/APIService/services/Reviews.js
export const reviewCycleGetMeta = CreateProcess({
	method: "GET",
	name: "getReviewCycleMeta",
	type: "REVIEWCYCLE:GETMETA",

	request: (props) => ({
		url: `/api/review_cycle/${props.reviewCycleID}/progress/meta/`,
	}),

	success: (response) => fromJS(response.data),
});

export const bulkUpdateReviewCycleForms = CreateProcess({
	method: "POST",
	name: "bulkUpdateReviewCycleForms",
	type: "REVIEWCYCLE:BULKUPDATE",

	request: (props) => ({
		url: `/api/review-cycles/${props.reviewCycleID}/forms/`,
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const createReviewCycle = CreateProcess({
	method: "POST",
	name: "createReviewCycle",
	type: "REVIEWCYCLE:CREATE",

	request: (props) => ({
		url: "/api/review_cycle/save/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const addFormToCycle = CreateProcess({
	method: "POST",
	name: "addFormToCycle",
	type: "REVIEWCYCLE:ADDFORM",

	request: (props) => ({
		url: "/api/review_cycle/add-form/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const deleteFormsFromCycle = CreateProcess({
	method: "POST",
	name: "deleteFormsFromCycle",
	type: "REVIEWCYCLE:DELETEFORM",

	request: (props) => ({
		url: "/api/review_cycle/delete-form/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const replaceFormsInCycle = CreateProcess({
	method: "POST",
	name: "replaceFormsInCycle",
	type: "REVIEWCYCLE:REPLACEFORM",

	request: (props) => ({
		url: "/api/review_cycle/replace-form/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const validateReviewCycleData = CreateProcess({
	method: "POST",
	name: "validateReviewCycleData",
	type: "REVIEWCYCLE:VALIDATEDATA",

	request: (props) => ({
		url: "/api/review_cycle/validate/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});
export const addSubjectsToReviewCycle = CreateProcess({
	method: "POST",
	name: "addSubjectsToReviewCycle",
	type: "REVIEWCYCLE:ADDSUBJECTS",

	request: (props) => ({
		url: `/api/review_cycle/${props.cycleID}/run_add_users/`,
		payload: props.payload,
	}),
	success: (response) => fromJS(response.data),
});

export const addEasyAdd = CreateProcess({
	method: "POST",
	name: "addEasyAdd",
	type: "REVIEWCYCLE:ADD_EASY_ADD",

	request: (props) => ({
		url: `/api/review-cycle/${props.cycleID}/easy-add-form/`,
		payload: props.payload,
	}),
	success: (response) => fromJS(response.data),
});

export const editEasyAdd = CreateProcess({
	method: "POST",
	name: "editEasyAdd",
	type: "REVIEWCYCLE:EDIT_EASY_ADD",

	request: (props) => ({
		url: `/api/${props.cycleID}/easy-add-form/${props.easyAddID}/`,
		payload: props.payload,
	}),
	success: (response) => fromJS(response.data),
});

export const deleteEasyAdd = CreateProcess({
	method: "DELETE",
	name: "deleteEasyAdd",
	type: "REVIEWCYCLE:DELETE_EASY_ADD",

	request: (props) => ({
		url: `/api/${props.cycleID}/easy-add-form/${props.easyAddID}/`,
		payload: props.payload,
	}),
	success: (response) => fromJS(response.data),
});

export const easyAddsApprove = CreateProcess({
	method: "POST",
	name: "easyAddsApprove",
	type: "REVIEWCYCLE:EASY_ADDS_APPROVE",

	request: (props) => ({
		url: `/api/review-cycle/${props.cycleId}/easy-adds-awaiting/approve/`,
	}),
	success: (response) => fromJS(response.data),
});

export const bulkEasyAddsDeactivate = CreateProcess({
	method: "POST",
	name: "easyAddsBulkDeactivate",
	type: "REVIEWCYCLE:EASY_ADDS_BULK_DEACTIVATE",

	request: (props) => ({
		url: `/api/review-cycle/${props.cycleId}/easy-adds-bulk-deactivate`,
	}),
	success: (response) => fromJS(response.data),
});
